import { render, staticRenderFns } from "./MovimentoDeposito.vue?vue&type=template&id=4f5266de&"
import script from "./MovimentoDeposito.vue?vue&type=script&lang=js&"
export * from "./MovimentoDeposito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports